import { useCallback } from "react";
import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";
import { navRoutes, routesFlat } from "@routes";
import { NavItem } from "./components";
import { Logout } from "../../Login/components";
import { BlackLogo } from "@assets/icons";
import { getBgColor, withScrollLogic } from "../helpers";
import useResizeObserver from "@/hooks/useResizeObserver";

function NavDesktop({
    scrollOpacity,
    topOffset = 0,
    gapOffset = 40,
    onHeightChange,
}) {
    const token = localStorage.getItem("token");
    const currentRoute = useLocation();
    const bgColor = getBgColor(currentRoute.pathname, scrollOpacity);
    const handleResize = useCallback(
        (entry) => {
            const height =
                entry?.borderBoxSize?.[0]?.blockSize ??
                entry?.contentBoxSize?.[0]?.blockSize ??
                entry?.contentRect?.height ??
                0;
            onHeightChange?.(height);
        },
        [onHeightChange],
    );

    const wrapperRef = useResizeObserver(handleResize);

    const computedTop = topOffset + gapOffset;

    return (
        <div
            ref={wrapperRef}
            className={parentWrapperStyle}
            style={{ ...bgColor, top: `${computedTop}px` }}
        >
            <Link to={routesFlat.landing}>
                <BlackLogo withText={true} className={logoStyle} />
            </Link>
            <div className={routesContainerStyle}>
                {navRoutes.map((route, i) => (
                    <NavItem route={route} index={i} />
                ))}
                {token && <Logout />}
            </div>
        </div>
    );
}

const parentWrapperStyle = clsx(
    "fixed z-50 hidden lg:flex w-full justify-between transition-all duration-300",
);
const logoStyle = clsx("h-[40px] w-auto self-center md:h-[60px]");
const routesContainerStyle = clsx(
    "flex gap-8 max-w-[800px] pr-6 items-center",
);

export default withScrollLogic(NavDesktop);
